import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { useEffect } from "react";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { useParams } from "react-router-dom";
import { socketIO } from "../../../socket";
import { setState } from "../../../redux/crudSlice";
var GetSocketUpdates = function (props) {
    var _documentDetailsGetBy;
    var value = props.value, onChange = props.onChange;
    var dispatch = useAppDispatch();
    var crud = useAppSelector(function (state) { return state.crud; });
    var storedSelectedChannel = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
    var documentDetailsGetById = crud.documentDetailsGetById;
    var id = useParams().id;
    var storedSelectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var socketRoom = "".concat(storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelId, "_").concat(storedSelectedBranch === null || storedSelectedBranch === void 0 ? void 0 : storedSelectedBranch.OrganizationId);
    var socket = null;
    socket = socketIO;
    useEffect(function () {
        if (socket && storedSelectedChannel !== null && storedSelectedChannel !== void 0 && storedSelectedChannel.ChannelId && storedSelectedBranch !== null && storedSelectedBranch !== void 0 && storedSelectedBranch.OrganizationId) {
            if (!socket.connected) {
                socket.connect();
            }
            socket.emit("joinRoom", socketRoom);
            socket.on("disconnect", function (reason) {
                console.log("socket disconnected jobcardDetails:", reason);
                if (reason === 'io server disconnect') {
                    socket.connect();
                    socket.emit("joinRoom", socketRoom);
                }
            });
            return function () {
                var _socket, _socket2;
                (_socket = socket) === null || _socket === void 0 || _socket.off("JobCardUpdate");
                (_socket2 = socket) === null || _socket2 === void 0 || _socket2.off("disconnect");
            };
        }
    }, []);
    useEffect(function () {
        if (socket && documentDetailsGetById && documentDetailsGetById.data) {
            var _socket3;
            (_socket3 = socket) === null || _socket3 === void 0 || _socket3.on('JobCardUpdate', function (socketData) {
                console.log("Socket Data -->>", socketData);
                if (socketData.JobCardId === id) {
                    var _socketData$ErrorMess;
                    var updatedDocumentDetails = _objectSpread({}, documentDetailsGetById);
                    var updateData = _objectSpread({}, socketData);
                    var updatedSourceMessage = _objectSpread(_objectSpread({}, updateData.SourceMessage), {}, {
                        ErrorMessage: (_socketData$ErrorMess = socketData.ErrorMessage) !== null && _socketData$ErrorMess !== void 0 ? _socketData$ErrorMess : ''
                    });
                    updateData.SourceMessage = updatedSourceMessage;
                    updatedDocumentDetails.data = _objectSpread(_objectSpread({}, updatedDocumentDetails.data), updateData);
                    onChange === null || onChange === void 0 || onChange(null, updateData);
                    dispatch(setState({
                        key: "documentDetailsGetById",
                        value: updatedDocumentDetails
                    }));
                }
            });
            socket.on("disconnect", function () {
                console.log("socket disconnected jobcardDetails");
            });
        }
    }, [socket, documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy = documentDetailsGetById.data) === null || _documentDetailsGetBy === void 0 ? void 0 : _documentDetailsGetBy.id, onChange]);
    return null;
};
export default GetSocketUpdates;
